import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const InboundDeliveryByIdQuery = graphql(/* GraphQL */ `
  query inboundDeliveryById($inboundDeliveryByIdInput: ByIdInput!) {
    inboundDeliveryById(input: $inboundDeliveryByIdInput) {
      ...InboundDelivery
    }
  }
`);
